import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";

const DeleteProperty = async (propertyId) => {
  try {
    const PropertyDoc = await doc(db, "properties", propertyId);

    await updateDoc(PropertyDoc, {
      is_deleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteProperty;
